/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SignInContainerLocal = {
    readonly error: string | null;
    readonly " $refType": "SignInContainerLocal";
};
export type SignInContainerLocal$data = SignInContainerLocal;
export type SignInContainerLocal$key = {
    readonly " $data"?: SignInContainerLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"SignInContainerLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SignInContainerLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "error",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = 'fae1e9caaa482362f09eaed06fb8fca2';
export default node;
